import React from "react"
import PropTypes from 'prop-types';
import {graphql} from "gatsby";
import { Layout, SEO } from "../components";
import "../styles/style.scss";
import PrismicRichTextSerializer from '../components/PrismicRichTextSerializer';

const Page = (props) => {
  const { path, data: { prismicPrivacy: { data } }} = props;
  return (
    <Layout path={path}>
      <SEO title={data.title.text} description="" pathname={path} />
      <section className="section">
        <div className="container">
          <div className="columns">
            <div className="column is-8 is-offset-2">
              <h1 className="title is-1">{data.title.text}</h1>
              <div className="content"><PrismicRichTextSerializer data={data.content.raw} /></div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Page;

Page.propTypes = {
  path: PropTypes.string,
  data: PropTypes.shape({
    prismicPrivacy: PropTypes.shape({
      data: PropTypes.shape({
        title: PropTypes.shape({
          text: PropTypes.string
        }).isRequired,
        content: PropTypes.shape({
          html: PropTypes.string
        })
      })
    })
  })
};

export const privacyQuery = graphql`
 query PrivacyBySlug($uid: String!) {
    prismicPrivacy(uid: { eq: $uid }) {
      uid
      data {
        title {
          text
        }
        content {
          raw
        }
      }
    }
  }
`;
